import {IGlobalState} from "./interface";

export const initialState: IGlobalState = {
    user: null,
    token: "",
    company: null,
    workplace: null,
    uploadUrl: "",
    currency: "",
    hydraDirectory: "",
    userAgent: {isMobile: false},
    version: "",
    sid: "",
    themeConfig : {},
    notifications: [],
    sideBarCollapsed: false,
    socketEvents: {},
    pagesConfig : {pages: []},
    pagesDecorator: {},
    callInProgress: {},
    headerConfig: {
        showCurrencySwitch: true,
        showCountrySwitch: true,
        showGlobalSearch: true,
        showTimer: true
    },
    userMenuConfig: {
        showProfile: true
    },
    initState: () => {},
    updateThemeConfig: () => {},
    createNotifications: () => {},
    updateNotifications: () => {},
    removeSocketEvents: () => {},
    addSocketEvent: () => {},
    updateToken: () => {},
    updateUser: () => {},
    updateCallStatus: () => {},
    updateCompany: () => {},
    updateWorkplace: () => {},
    collapseSidebar: () => {}
};
